import { isFeatureEnabled } from '@lumapps/features';

export const MULTI_REACTION_FF = 'multi-reaction';

/** Multi-reaction feature enabled. */
export const isMultiReactionFeatureEnabled = isFeatureEnabled(MULTI_REACTION_FF);
